import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const StyledSubmit = styled.input`
    background-color: ${props =>
        props.disabled ? '#E5E5E5' : props.theme.colors.primaryYellow};
    color: ${props =>
        props.disabled ? '#9D9D9D' : props.theme.colors.primaryGray};
    font-size: 14px;
    padding-top: 14px;
    padding-bottom: 14px;
    font-family: ${props => props.theme.fonts[1]}, sans-serif;
    font-weight: 500;
    border-radius: ${props => props.theme.borderRadius.default};
    border: none;
    width: 155px;
    text-align: center;
    align-self: flex-end;
    margin: 1em 1em 5em 0;
    cursor: ${props => (props.disabled ? 'no-drop' : 'pointer')};
    -webkit-appearance: none;

    @media screen and (max-width: 320px) {
        width: 130px;
    }

    @media screen and (max-width: 45em) {
        margin: 0em 0em 3em 0;
    }

    &:hover {
        color: ${props =>
            props.color === 'yellow'
                ? props.theme.colors.primaryYellow
                : props.theme.colors.primaryGray};
        background-color: ${props =>
            props.color === 'yellow'
                ? props.theme.colors.primaryGray
                : props.theme.colors.primaryYellow};
    }
`;

export default function CreditSubmitButton({
    color,
    id,
    text,
    agreeToTerms,
    buttonref,
    onPrevClick,
    buttonType,
}) {
    if (agreeToTerms === undefined) {
        agreeToTerms = true;
    }
    return (
        <StyledSubmit
            id={id ? id : ''}
            color={color}
            type={buttonType ? buttonType : 'submit'}
            value={text}
            disabled={!agreeToTerms ? true : false}
            ref={buttonref}
            onClick={onPrevClick}
        ></StyledSubmit>
    );
}

CreditSubmitButton.propTypes = {
    color: PropTypes.string,
    text: PropTypes.string.isRequired,
};

CreditSubmitButton.defaultProps = {
    color: 'yellow',
};
